// extracted by mini-css-extract-plugin
export var actions = "_u2-4";
export var item = "_u2-1";
export var price = "_u2-3";
export var quantity = "_u2-2";
export var table = "_u2-0";